<template>
    <ion-toolbar
        class="custom-toolbar ion-background-purple-background"
        :class="{'remove-border no-height': empty}"
    >
        <template v-if="!empty">
            <ion-buttons slot="start" collapse>
                <slot name="start">
                    <ion-back-button
                        v-if="backButton"
                        :icon="chevronBack"
                        :text="$t('button.back')"
                        @click="fixedRoute ? routeBackFixed() : $router.back()"
                        class="force-color custom-back-button resize-back-button"
                        :default-href="defaultHref ?? '/home'"
                    />
                </slot>
            </ion-buttons>

            <ion-title>
                <slot>
                    {{ title ?? $route.meta?.title ?? 'Octopus' }}
                </slot>
            </ion-title>

            <ion-buttons slot="end" collapse>
                <slot name="end"/>
            </ion-buttons>

            <div slot="primary" v-if="$slots['primary']">
                <slot name="primary"/>
            </div>

            <div slot="secondary" v-if="$slots['secondary']">
                <slot name="secondary"/>
            </div>
        </template>
    </ion-toolbar>
</template>

<script setup lang="ts">
import { IonBackButton, IonButtons, IonTitle, IonToolbar, useIonRouter } from "@ionic/vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { CustomHeaderProps } from "@/types/props"

import { chevronBack } from "ionicons/icons";

const props = withDefaults(defineProps<CustomHeaderProps>(), {
    color: ION_VARIANT.PURPLE
})

const { navigate } = useIonRouter()

const routeBackFixed = (): void => {
    navigate(props.fixedRoute, props.noAnimation ? 'none' : 'back', 'pop')
}
</script>

<style scoped>
.force-background {
    background: var(--background);
}
</style>
